import { render, staticRenderFns } from "./tax.vue?vue&type=template&id=74713370&"
import script from "./tax.vue?vue&type=script&lang=js&"
export * from "./tax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports